import dynamic from 'next/dynamic';

import {
  WIDGET_TYPES as TYPES,
  WIDGET_TEMPLATES as TEMPLATES,
} from './constants';
import { WidgetPlugin } from './types';
import { EmbededRendererProps } from '../Embeded/Embeded';

export const EmbededPlugin: WidgetPlugin<EmbededRendererProps> = {
  type: TYPES.EMBED,
  template: TEMPLATES.BASIC,
  component: dynamic(() =>
    import('@/components/organisms').then(mod => mod.EmbededRenderer),
  ),
  mapProps: widget => {
    return {
      html: !Array.isArray(widget.template.parameters)
        ? widget.template.parameters?.content || ''
        : '',
    };
  },
};
